import { faEdit as keywordConfig } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Filters, calculateFrom, calculateTo, timePeriodsIds as timePeriods } from 'botbit-ui-components';
import _ from 'lodash';
import { MDBCard, MDBCardBody, MDBCol, MDBContainer, MDBRow, MDBBtn } from 'mdbreact';
import React, { useEffect, useState } from 'react';
import Moment from 'react-moment';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { getKeywordsForCompany, getLastUpdateTime, getReviewSentimentByMonth, getReviewSentimentSummaryByMonth, getSentimentsByDay, sendFeedbackForReviewSentiment } from '../../../api/feedbackApi';
import { setLoading } from '../../../commons/components/application/miscActions';
import { firePageView } from "../../../commons/components/utils/trackers";
import { SocialSourceNames } from '../../../commons/enums/SocialSource';
import { translations } from '../../../config/translations/Feedback/SentimentContainer';
import { translations as monthTranslations } from '../../../config/translations/Months';
import translate from '../../../config/translations/translate';
import { GradientHelper } from './GradientHelper';
import KeywordsDistributionByComments from './KeywordsDistributionByComments';
import KeywordsDistributionByStores from './KeywordsDistributionByStores';
import KeywordsSummary from './KeywordsSummary';
import { SectionTitle } from './SectionTitle';
import SendFeedbackModal from './SendFeedbackModal';
import './SentimentContainer.scss';
import SentimentDayDetail from './SentimentDayDetail';
import SentimentMonthCalendarGraph from './SentimentMonthCalendarGraph';
import SentimentMonthEvolutionGraph from './SentimentMonthEvolutionGraph';
import withEventTracking, {trackers} from "../../../config/withEventTracking";
import { useNotificationTracking } from '../../../commons/utils/useNotificationTracking';
import MobileScreenUnavailableMessage from '../../../commons/components/application/MobileScreenUnavailableMessage';

const SentimentContainer = ({ t, trackEvent }) => {
	const availableCompanies = useSelector((state) => state.application.availableCompanies);
	const selectedCompany = useSelector((state) => state.application.selectedCompany);
	const availableStores = useSelector(state => state.application.availableStores)
	// const isMOTU = useSelector(state => state.login.admin.objectAccess === 'ALL')


	useNotificationTracking(trackEvent, 'sentiment_analysis');

	const [filterValues, setFilterValues] = useState({
		// timePeriod: [{ value: timePeriods.LAST_6_MONTHS }],
		companies: [selectedCompany.id],
		stores: [],
		socialSources: [],
		keywords: [],
	})
	const [statisticsByMonthSummary, setStatisticsByMonthSummary] = useState(undefined)
	const [statisticsByMonth, setStatisticsByMonth] = useState(undefined)
	const [statisticsByDay, setStatisticsByDay] = useState(undefined)

	const [selectedDay, setSelectedDay] = useState(undefined)
	const [selectedDayStats, setSelectedDayStats] = useState(undefined)
	const [selectedMonth, setSelectedMonth] = useState(undefined)
	const [selectedYear, setSelectedYear] = useState(undefined)

	const [reviewSentimentIdForFeedback, setReviewSentimentIdForFeedback] = useState(undefined)
	const [showFeedbackModal, setShowFeedbackModal] = useState(false)

	const [lastUpdateTime, setLastUpdateTime] = useState(undefined)

	const [firstLoad, setFirstLoad] = useState(true)
	const [keywords, setKeywords] = useState([]);
	// const [selectedKeyword, setSelectedKeyword] = useState(undefined);

	const [lastYearSelected, setLastYearSelected] = useState(undefined)
	const [lastMonthSelected, setLastMonthSelected] = useState(undefined)
	const [windowWidth, setWindowWidth] = useState(window.innerWidth);  
	const [isMobileModalOpen, setIsMobileModalOpen] = useState(window.innerWidth < 550);

	const history = useHistory();

	const schemas = {
		socialSources: {
			id: "socialSources",
			type: "multiselect",
			options: [
				{
					value: 1,
					text: SocialSourceNames[1]
				},
				{
					value: 2,
					text: SocialSourceNames[2]
				},
				{
					value: 3,
					text: SocialSourceNames[3]
				},
			],
			placeholder: t("filters.socialSource"),
			label: t("filters.socialSource"),
			visible: true,
			priority: true,
			defaultValues: filterValues.socialSources,
		},
		// timePeriod: {
		// 	id: 'timePeriod',
		// 	label: t("filters.timePeriod"),
		// 	type: 'timeperiod',
		// 	icon: 'calendar-alt',
		// 	placeholder: t("custom"),
		// 	priority: true,
		// 	visible: true,
		// 	options: [timePeriods.THIS_MONTH, timePeriods.LAST_2_MONTHS, timePeriods.LAST_3_MONTHS, timePeriods.LAST_6_MONTHS, timePeriods.THIS_YEAR],
		// 	defaultValues: filterValues.timePeriod,
		// },
		companies: {
			id: "companies",
			label: t("filters.company"),
			type: "select",
			icon: "building",
			placeholder: t("filters.allCompanies"),
			priority: true,
			visible: availableCompanies.length > 1,
			options: availableCompanies.map(s => ({ value: s.id, text: s.name })),
			defaultValues: filterValues.companies,
			search: true
		},
		stores: {
			id: "stores",
			label: t("filters.store"),
			type: "multiselect",
			icon: "store-alt",
			placeholder: t("filters.allStores"),
			priority: true,
			visible: true,
			options: availableStores.map(s => ({ value: s.id, text: s.name, dependencyId: s.companyId })),
			search: true,
			defaultValues: filterValues.stores,
			dependsOn: "companies"
		},
		keywords: {
			id: "keywords",
			label: t("filters.keywords"),
			type: "select",
			icon: "hashtag",
			placeholder: t("filters.keywords"),
			priority: true,
			visible: true,
			options: keywords.map(s => ({ value: s.id, text: s.keyword })),
			// search: true,
			defaultValues: []
		}
	};

	const dispatch = useDispatch();

	const fetchSummaryByMonth = () => {
		dispatch(setLoading(true));
		fetchLastUpdateTime()
		getReviewSentimentSummaryByMonth(
			calculateFrom(timePeriods.LAST_6_MONTHS),
			calculateTo(timePeriods.LAST_6_MONTHS),
			// calculateFrom(filterValues.timePeriod[0].value),
			// calculateTo(filterValues.timePeriod[0].value),
			filterValues.companies,
			filterValues.stores,
			filterValues.socialSources,
			filterValues.keywords
		).then(rsp => {
			const monthList = rsp.data.data;
			const monthCopy = rsp.data.data.slice().reverse();
			const lastMonthWithData = monthCopy.find(element => (element.totalNegativeReviews + element.totalPositiveReviews) > 0)
			const lastMonthSelectedData = monthCopy.find(element => element.year === lastYearSelected && element.month === lastMonthSelected)
			setStatisticsByMonthSummary(monthList)
			setStatisticsByMonth(undefined)
			setStatisticsByDay(undefined)
			setSelectedDayStats(undefined)
			if (lastMonthSelectedData) {
				setSelectedMonth(lastMonthSelected)
				setSelectedYear(lastYearSelected)
			}
			else if (lastMonthWithData) {
				setSelectedMonth(lastMonthWithData.month)
				setSelectedYear(lastMonthWithData.year)
			} else {
				setLastYearSelected(undefined)
				setLastMonthSelected(undefined)
				// if there's no data no fetchMonthDetails will be triggered, so I must disable loader
				dispatch(setLoading(false));
			}
		}).finally(() => {
			setFirstLoad(false)
		}).catch(() => {
			// if there's an error no fetchMonthDetails will be triggered, so I must disable loader
			dispatch(setLoading(false));
		});
	};

	const fetchMonthDetails = () => {
		if (!selectedMonth || !selectedYear)
			return;
		dispatch(setLoading(true));
		getReviewSentimentByMonth(
			filterValues.companies,
			filterValues.stores,
			filterValues.socialSources,
			selectedYear,
			selectedMonth,
			filterValues.keywords
		).then(rsp => {
			setStatisticsByMonth(rsp.data.data)
			setStatisticsByDay(undefined)
			setSelectedDayStats(undefined)
		}).finally(() => {
			dispatch(setLoading(false));
		});
	};

	const fetchDayReviews = () => {
		if (!selectedMonth || !selectedYear)
			return;
		dispatch(setLoading(true));
		getSentimentsByDay(
			filterValues.companies,
			filterValues.stores,
			filterValues.socialSources,
			selectedYear,
			selectedMonth,
			selectedDay.getDate(),
			filterValues.keywords
		).then(rsp => {
			const reviewsByDay = rsp.data.data
			setStatisticsByDay(reviewsByDay)
		}).finally(() => {
			dispatch(setLoading(false));
		});
	};

	const sendFeedback = (id, text, isPositive) => {
		dispatch(setLoading(true));
		sendFeedbackForReviewSentiment(id, text, isPositive).then((rsp) => {
			const reviewUpdated = rsp.data.data
			const newStatiticsByDay = statisticsByDay.map((elem) => {
				return (elem.id === reviewUpdated.id) ? reviewUpdated : elem
			})
			setStatisticsByDay(newStatiticsByDay)
			setReviewSentimentIdForFeedback(undefined)
		}).finally(() => {
			setShowFeedbackModal(false)
			dispatch(setLoading(false));
		})
	}

	const fetchLastUpdateTime = () => {
		getLastUpdateTime(filterValues.companies[0]).then((rsp) => {
			setLastUpdateTime(rsp.data.data);
		})
	}

	const changeKeywordFilter = (keywordId) => {
		const newFilterValues = { ...filterValues }
		newFilterValues.keywords = [keywordId]
		setFilterValues(newFilterValues)
	}

	useEffect(() => {
		firePageView();
	}, []);

	useEffect(() => {
		const handleResize = () => {
			setWindowWidth(window.innerWidth);
		};

		window.addEventListener('resize', handleResize);
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	useEffect(() => {
		if (windowWidth < 550) {
			setIsMobileModalOpen(true);
		} else {
			setIsMobileModalOpen(false);
		}
	}, [windowWidth]);

	useEffect(() => {
		getKeywordsForCompany(selectedCompany.id).then((rsp => {
			setKeywords(rsp.data.data)
		}))
	}, []);

	useEffect(() => {
		setLastMonthSelected(selectedMonth)
		setLastYearSelected(selectedYear)
		setSelectedDay(undefined)
		setSelectedMonth(undefined)
		setSelectedDayStats(undefined)
		setSelectedYear(undefined)
		fetchSummaryByMonth()

		// if (filterValues.keywords.length === 0) {
		// 	setSelectedKeyword(undefined)
		// } else {
		// 	const keywordToSelect = keywords.find(kw => kw.id === filterValues.keywords[0])
		// 	setSelectedKeyword(keywordToSelect)
		// }

	}, [JSON.stringify(filterValues)])

	useEffect(() => {
		if (selectedYear && selectedMonth)
			fetchMonthDetails()
	}, [selectedYear, selectedMonth])

	useEffect(() => {
		if (selectedDay)
			fetchDayReviews()
	}, [selectedDay])

	const onMonthSelected = (year, month) => {
		if (selectedMonth !== month || selectedYear !== year) {
			setStatisticsByMonth(undefined)
			setStatisticsByDay(undefined)
		}
		setLastMonthSelected(month)
		setLastYearSelected(year)
		setSelectedMonth(month)
		setSelectedYear(year)
	}

	const onDaySelected = (day, dayStats) => {
		setSelectedDay(day)
		setSelectedDayStats(dayStats)
	}

	const onSendFeedbackClicked = (reviewSentimentId) => {
		setReviewSentimentIdForFeedback(reviewSentimentId)
		setShowFeedbackModal(true)
	}

	const hideFeedbackModal = () => {
		setShowFeedbackModal(false)
	}

	// const getKeywordName = (keywordId) => {
	// 	const keywordToExtractName = keywords.find(kw => kw.id === keywordId)
	// 	return keywordToExtractName && keywordToExtractName.keyword
	// }

	if(keywords.length === 0) {
		return (
			<>
				<MobileScreenUnavailableMessage isOpen={isMobileModalOpen} />
			<MDBContainer className="sentiment-container">
				<div className="empty-state-container">
						<svg width="317" height="229" viewBox="0 0 317 229" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0)"><path d="M278.085 111.544H275.263V223.054H278.085V111.544Z" fill="#3F3D56"></path><path d="M304.126 125.755C304.306 164.747 276.885 196.484 276.885 196.484C276.885 196.484 249.172 165.001 248.993 126.009C248.813 87.0167 276.234 55.2801 276.234 55.2801C276.234 55.2801 303.946 86.7625 304.126 125.755Z" fill="#3F3D56"></path><path d="M221.662 164.011H220.211V221.364H221.662V164.011Z" fill="#3F3D56"></path><path d="M235.057 171.32C235.149 191.375 221.046 207.698 221.046 207.698C221.046 207.698 206.793 191.506 206.7 171.451C206.608 151.396 220.711 135.073 220.711 135.073C220.711 135.073 234.964 151.266 235.057 171.32Z" fill="#3F3D56"></path><path d="M250.269 229C271.985 229 289.59 226.3 289.59 222.97C289.59 219.64 271.985 216.94 250.269 216.94C228.552 216.94 210.948 219.64 210.948 222.97C210.948 226.3 228.552 229 250.269 229Z" fill="#3F3D56"></path><path d="M253.512 82.433C250.181 76.8016 243.59 76.5391 243.59 76.5391C243.59 76.5391 237.167 75.7175 233.047 84.2942C229.207 92.2885 223.907 100.007 232.194 101.879L233.691 97.2177L234.618 102.226C235.798 102.31 236.981 102.331 238.164 102.286C247.038 101.999 255.489 102.37 255.217 99.1841C254.856 94.9489 256.717 87.8516 253.512 82.433Z" fill="#2F2E41"></path><path d="M241.515 93.0383C241.515 93.0383 245.82 99.0683 243.237 103.95C240.654 108.831 249.264 114 249.264 114L255.578 100.217C255.578 100.217 248.116 95.3354 250.125 90.7411L241.515 93.0383Z" fill="#FBBEBE"></path><path d="M244.385 95.6225C248.507 95.6225 251.848 92.28 251.848 88.1569C251.848 84.0337 248.507 80.6912 244.385 80.6912C240.264 80.6912 236.923 84.0337 236.923 88.1569C236.923 92.28 240.264 95.6225 244.385 95.6225Z" fill="#FBBEBE"></path><path d="M218.56 96.7872L224.796 88.7375C224.796 88.7375 226.992 80.2999 230.172 80.7277C233.352 81.1554 228.916 90.8465 228.916 90.8465L222.719 99.7567L218.56 96.7872Z" fill="#FBBEBE"></path><path d="M250.125 203.875L252.135 214.499L256.44 215.648L255.292 203.014L250.125 203.875Z" fill="#FBBEBE"></path><path d="M293.465 192.389L301.214 203.014L304.371 204.449L306.955 200.142L299.205 190.092L293.465 192.389Z" fill="#FBBEBE"></path><path d="M248.403 109.405L243.615 103.1C243.615 103.1 234.339 104.811 233.478 105.673C232.617 106.534 235.775 122.327 235.775 122.327C235.775 122.327 236.349 126.634 238.932 128.931L241.515 130.654L262.754 126.347L263.553 116.892C263.843 113.449 263.412 109.982 262.286 106.715C261.16 103.448 259.364 100.452 257.014 97.9197L253.318 98.4251L248.403 109.405Z" fill="#575A89"></path><path d="M234.627 106.247L233.191 105.673L226.59 105.098C226.59 105.098 224.294 104.524 224.868 103.375C225.442 102.227 226.016 101.94 224.868 101.653C223.72 101.365 223.433 101.078 223.72 100.217C224.007 99.3554 225.729 97.6326 225.729 97.6326L220.85 93.6126C220.85 93.6126 220.586 93.7995 220.159 94.1452C217.736 96.1075 210.071 103.187 215.683 110.267C222.285 118.594 230.034 123.475 236.349 121.753L234.627 106.247Z" fill="#575A89"></path><path d="M240.941 129.218V133.238C240.941 133.238 238.358 138.12 239.219 142.714C240.08 147.308 240.367 149.605 240.367 149.605C240.46 153.513 241.138 157.384 242.376 161.091C244.385 166.834 237.784 204.449 246.107 205.024C254.431 205.598 259.023 206.172 261.606 203.301C264.189 200.429 257.301 151.041 257.301 151.041C257.301 151.041 280.836 200.142 285.715 198.132C290.595 196.122 302.936 191.528 301.501 188.944C300.066 186.359 263.902 128.931 263.902 128.931L262.754 126.347L240.941 129.218Z" fill="#2F2E41"></path><path d="M254.717 212.489C254.717 212.489 250.125 212.202 250.125 213.638C250.125 215.074 247.829 219.955 247.829 219.955C247.829 219.955 246.107 225.698 250.699 225.124C255.291 224.549 258.162 219.381 258.162 219.381L257.014 213.925L254.717 212.489Z" fill="#2F2E41"></path><path d="M302.649 202.439C302.649 202.439 298.631 199.855 298.918 201.578C299.205 203.301 299.492 207.895 301.501 208.182C303.51 208.469 309.538 210.192 309.825 210.767C310.112 211.341 317 213.638 317 209.905C317 206.172 312.695 203.301 312.695 203.301L307.816 199.568C307.816 199.568 304.658 199.281 304.084 201.291C303.51 203.301 302.649 202.439 302.649 202.439Z" fill="#2F2E41"></path><path d="M244.396 81.3353C247.028 81.3353 249.162 79.2007 249.162 76.5677C249.162 73.9346 247.028 71.8 244.396 71.8C241.764 71.8 239.631 73.9346 239.631 76.5677C239.631 79.2007 241.764 81.3353 244.396 81.3353Z" fill="#2F2E41"></path><path d="M239.129 75.313C239.129 74.1355 239.565 72.9997 240.352 72.1244C241.14 71.2491 242.223 70.6962 243.393 70.5722C243.226 70.5546 243.059 70.5456 242.891 70.5454C241.628 70.5454 240.415 71.0477 239.522 71.9418C238.628 72.8359 238.126 74.0486 238.126 75.313C238.126 76.5775 238.628 77.7902 239.522 78.6843C240.415 79.5784 241.628 80.0807 242.891 80.0807C243.059 80.0805 243.226 80.0715 243.393 80.0539C242.223 79.9299 241.14 79.377 240.352 78.5017C239.565 77.6263 239.129 76.4905 239.129 75.313Z" fill="#2F2E41"></path><path d="M252.039 81.8902L245.527 78.4778L236.535 79.8739L234.675 88.0942L239.306 87.9159L240.6 84.896V87.8662L242.737 87.7841L243.977 82.9759L244.752 88.0942L252.349 87.9392L252.039 81.8902Z" fill="#2F2E41"></path><path d="M251.649 129.883L241.607 130.155C241.607 130.155 233.039 131.823 233.519 128.363C234 124.903 242.359 126.113 242.359 126.113L251.51 124.717L251.649 129.883Z" fill="#FBBEBE"></path><path d="M259.594 97.433C260.099 97.3565 260.614 97.4628 261.048 97.7328C261.481 98.0027 261.804 98.4186 261.958 98.9054C263.924 105.103 269.98 125.843 263.963 128.689C256.876 132.04 251.703 131.893 251.703 131.893L248.935 125.074L251.455 122.707L254.146 105.4L255.435 98.0633L259.594 97.433Z" fill="#575A89"></path><path opacity="0.4" d="M257.732 108.975L256.584 120.46L246.538 124.767L257.732 122.183V108.975Z" fill="black"></path><path d="M203.556 71.0569C206.791 71.9146 209.591 73.949 211.406 76.7623L212.345 78.2169L212.392 78.277L228.863 83.0985C229.165 83.1869 229.42 83.3903 229.573 83.665C229.727 83.9397 229.767 84.2637 229.684 84.5673L228.405 89.2578C228.363 89.4105 228.292 89.5536 228.195 89.6786C228.098 89.8037 227.977 89.9083 227.839 89.9864C227.701 90.0646 227.55 90.1147 227.393 90.1339C227.235 90.1532 227.076 90.1411 226.924 90.0985L210.449 85.4916L210.449 85.4921L208.794 86.1179C205.747 87.2703 202.406 87.3839 199.288 86.4411L203.556 71.0569Z" fill="#3F3D56"></path><path d="M220.901 84.6598C221.057 84.1264 220.373 83.4569 219.373 83.1642C218.374 82.8716 217.437 83.0668 217.281 83.6001C217.125 84.1335 217.809 84.8031 218.808 85.0957C219.808 85.3883 220.745 85.1931 220.901 84.6598Z" fill="#575A89"></path><path d="M220.06 85.1516C220.442 85.1516 220.751 84.8419 220.751 84.4598C220.751 84.0778 220.442 83.7681 220.06 83.7681C219.678 83.7681 219.368 84.0778 219.368 84.4598C219.368 84.8419 219.678 85.1516 220.06 85.1516Z" fill="#3F3D56"></path><path d="M204.933 79.9413C206.306 75.7038 205.867 71.7649 203.952 71.1436C202.036 70.5222 199.37 73.4536 197.997 77.6911C196.623 81.9286 197.062 85.8675 198.978 86.4888C200.893 87.1102 203.559 84.1787 204.933 79.9413Z" fill="#38D39F"></path></g><defs><clipPath id="clip0"><rect width="317" height="229" fill="white"></rect></clipPath></defs></svg>
					<h2 className="empty-state-title">
						{t('emptyState.title')}
					</h2>
					<p className="empty-state-description">
						{t('emptyState.description')}
					</p>
					<MDBBtn 
						color="primary" 
						onClick={() => history.push('/settings/sentiments/keywords')}
					>
						{t('emptyState.button')}
					</MDBBtn>
				</div>
			</MDBContainer>
			</>
		)
	}

	return (
		<>
			<MobileScreenUnavailableMessage isOpen={isMobileModalOpen} />
		<MDBContainer className="sentiment-container">
			<SendFeedbackModal
				show={showFeedbackModal}
				hide={hideFeedbackModal}
				reviewSentimentId={reviewSentimentIdForFeedback}
				onAccept={sendFeedback}
			/>
			{/* Filters */}
			<MDBRow size='12'>
				<MDBCol size='12'>
					<Filters
						title={t("title")}
						schemas={schemas}
						values={filterValues}
						onChange={(newValues) => {
							if (!_.isEqual(newValues, filterValues)) {
								setFilterValues(newValues)
							}
						}}
						showInfo
					/>
					<div className="configure-topics-button-container" style={{ marginTop: '10px', marginBottom: '10px' }}>
						<MDBBtn 
							color="light" 
							size="sm"
							className="configure-topics-btn"
							onClick={() => history.push('/settings/sentiments/keywords')}
							style={{
								border: '1px solid #ddd',
								borderRadius: '4px',
								padding: '8px 16px',
								fontSize: '14px',
								fontWeight: '500',
								color: '#333',
								backgroundColor: '#fff',
								boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
								transition: 'all 0.2s ease',
								textTransform: 'none'
							}}
							onMouseEnter={(e) => {
								e.target.style.backgroundColor = '#f8f9fa';
								e.target.style.borderColor = '#adb5bd';
							}}
							onMouseLeave={(e) => {
								e.target.style.backgroundColor = '#fff';
								e.target.style.borderColor = '#ddd';
							}}
						>
							<FontAwesomeIcon icon={keywordConfig} style={{ marginRight: '8px' }} />
							{t('configureKeywords.button')}
						</MDBBtn>
					</div>
				</MDBCol>
			</MDBRow>
			{/* Last 6 months evolution */}
			<MDBRow size='12'>
				<MDBCol size='12'>
					{(statisticsByMonthSummary && statisticsByMonthSummary.length > 0) ?
						<>
							<h4 className='principal-title'>
								{t('periodEvolutionSection.title')}
							</h4>
							<MDBCard className='mb-4'>
								<MDBCardBody className='card-content'>
									<SectionTitle
										help={[t('periodEvolutionSection.evolutionChart.help1'), t('periodEvolutionSection.evolutionChart.help2')]}
										title={t('periodEvolutionSection.evolutionChart.title')}
										name={'sentiment-period-summary'}
									/>
									<SentimentMonthEvolutionGraph
										onMonthSelected={onMonthSelected}
										statisticsByMonth={statisticsByMonthSummary}
									/>
									{lastUpdateTime && <>
										<div className="last-update-box">{t('periodEvolutionSection.lastUpdateTime')}
											<Moment
												fromNow
												locale={navigator.language.toLocaleLowerCase()}
											>{lastUpdateTime}</Moment>
										</div>
									</>}
								</MDBCardBody>
							</MDBCard>
						</>
						: !firstLoad && <div className="empty-state" style={{ height: 300 }}>
							<h1>{t("periodEvolutionSection.emptyState")}</h1>
						</div>
					}
				</MDBCol>
			</MDBRow>
			{/* Keywords analysis */}
			<MDBRow>
				<MDBCol size='12'>
					{statisticsByMonth && <>
						<h4 className='principal-title'>
							{t('keywordAnalysisSection.title')}&nbsp;-&nbsp;{t(`months.${selectedMonth}`)}&nbsp;{selectedYear}
						</h4>
						<MDBRow>
							<MDBCol size='12' xl='4'>
								<MDBRow>
									<MDBCol size='12' md='5' xl='12'>
										<MDBCard className='mb-4 fixed-height-350'>
											<MDBCardBody className='card-content'>
												<KeywordsSummary
													sentimentsByKeyword={statisticsByMonth.sentimentsByKeyword}
													changeKeywordFilter={changeKeywordFilter}
													selectedKeywords={filterValues.keywords}
												/>
												<div className='gradient-help-container'>
													<GradientHelper
														leftText={t('sentimentColorHelp.negative')}
														rightText={t('sentimentColorHelp.positive')}
													/>
												</div>
												<div className='bottom-comment-fixed'>
													<span>
														{t('configureKeywords.main')}&nbsp;
													</span>
													<span onClick={() => history.push('/settings/sentiments/keywords')} className="keyword-help-link">
														{t('configureKeywords.link')}&nbsp;
													</span>
													<span onClick={() => history.push('/settings/sentiments/keywords')} className="keyword-help-link">
														<FontAwesomeIcon icon={keywordConfig} size='1x' />
													</span>
												</div>
											</MDBCardBody>
										</MDBCard>
									</MDBCol>
									<MDBCol size='12' md='7' xl='12'>
										<MDBCard className='mb-4 fixed-height-350'>
											<MDBCardBody className='card-content'>
												<KeywordsDistributionByComments
													sentimentsByKeyword={statisticsByMonth.sentimentsByKeyword}
													selectedKeywords={filterValues.keywords}
												/>
											</MDBCardBody>
										</MDBCard>
									</MDBCol>
								</MDBRow>
							</MDBCol>
							{/* <MDBCol size='12' xl='5' lg='4' md='6' sm='6'> */}
							<MDBCol size='12 'xl='8'>
								<MDBCard className='mb-4 fixed-height-725'>
									<MDBCardBody className='card-content'>
										<KeywordsDistributionByStores
											sentimentsByStore={statisticsByMonth.sentimentsByStore}
										/>
									</MDBCardBody>
								</MDBCard>
							</MDBCol>
							{/* { selectedKeyword && statisticsByMonth && <MDBCol size='12' lg='4' md='4' sm='6'>
								<MDBCard className='mb-4'>
									<MDBCardBody className='card-content'>
										<KeywordStatistics
											keyword={selectedKeyword}
											sentimentsByKeyword={statisticsByMonth.sentimentsByKeyword}
										/>
									</MDBCardBody>
								</MDBCard>
							</MDBCol>} */}
							{/* {isMOTU && filterValues.companies[0] === 1016 && <MDBCol size='12' lg='12' md='12' sm='12'>
								<MDBCard className='mb-4'>
									<MDBCardBody className='card-content'>
										<WordCloud 
											words={statisticsByMonth.wordOcurrences}
										/>
									</MDBCardBody>
								</MDBCard>
							</MDBCol>} */}
						</MDBRow>
					</>
					}
				</MDBCol>
			</MDBRow>
			{/* daily statistics */}
			{selectedYear && selectedMonth && statisticsByMonth && <MDBRow size='12'>
				<MDBCol size='12' className='selected-keyword-analysis'>
					<h4 className='principal-title'>
						{t('dailyStatisticsSection.title')}&nbsp;-&nbsp;{t(`months.${selectedMonth}`)}&nbsp;{selectedYear}
					</h4>
				</MDBCol>
				<MDBCol size='12' lg='4'>
					<MDBCard className='mb-4'>
						<MDBCardBody className='card-content fixed-height-400'>
							<SentimentMonthCalendarGraph
								onDaySelected={onDaySelected}
								month={selectedMonth}
								year={selectedYear}
								monthStatistics={statisticsByMonth.statisticsByDay}
							/>
						</MDBCardBody>
					</MDBCard>
				</MDBCol>
				<MDBCol size='12' lg='8'>
					<div className="sentiments-by-day">
						<SentimentDayDetail
							sentimentsByDay={statisticsByDay}
							dayStats={selectedDayStats}
							onSendFeedback={onSendFeedbackClicked}
							sendFeedback={sendFeedback}
							activeKeywords={keywords}
						/>
					</div>
				</MDBCol>
			</MDBRow>
			}

			<br />
			<br />
			<br />

		</MDBContainer >
		</>
	);
};

SentimentContainer.translations = {
	...translations,
	...monthTranslations
};

export default withEventTracking(translate(SentimentContainer));